import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AnexoIcone from '../../../../../../components/Anexos/AnexoIcone';
import urlHelper from '../../../../../../helpers/UrlHelper';

import './style.scss';

export default function FileDownload({ conteudo, url, arquivo=null }) {
  var nome = conteudo || url;
  var index = url && url.indexOf('.');
  var extensao = url && index && url.substring(index + 1);

  function abrirArquivo() {
    const novaUrl = urlHelper.alterarUrlArquivoComNomeOriginal(url, arquivo?.nome_arquivo, arquivo?.file_name)
    if(!novaUrl) {
      return
    }
    urlHelper.download(novaUrl)
  }

  return (
    <>
      {
        <>
          <a className="linkFile" href="#" onClick={() => abrirArquivo()} target="_blank" rel="noreferrer">
            <Row >
              <Col sm={2}>
                <AnexoIcone anexo={extensao} style={{ fontSize: "3em" }} />
              </Col>
              <Col style={{marginTop: "0.75rem", marginLeft: "0.5rem"}}>
                  {nome}
              </Col>
            </Row>
          </a>
        </>
      }
    </>)
}
